import PropTypes from 'prop-types'

import { Typography, Box, Button, Alert } from '@mui/material'
import useTranslations from '../../i18n/useTranslations'
import { ReactComponent as Sliders } from '../../assets/icons/sliders.svg'
import { ReactComponent as IconArrowLineLeft } from '../../assets/icons/arrow-left.svg'
import { useStyles } from './styles'

const ReportsView = ({ children, seeConfig, onClickConfig, showAlert }) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.rowHeader}>
        <Box className={classes.textHeader}>
          <Typography variant="h1" className={classes.title}>
            {t('reports:title')}
          </Typography>
          <Typography className={classes.colorMain}>
            {t('reports:description')}
          </Typography>
          <Typography className={classes.subtitle}>
            {t('reports:description-2')}
          </Typography>
          <Typography className={classes.subtitle}>
            {t('reports:description-3')}
          </Typography>
        </Box>
        <Box className={classes.viewButtonsBox}>
          {showAlert ? (
            <Alert
              severity={showAlert?.severity ?? 'success'}
              iconAlignment="top"
            >
              {t(showAlert?.text)}
            </Alert>
          ) : (
            <>
              <Button
                className={classes.viewButtons}
                onClick={onClickConfig}
                variant="text"
                size="small"
                startIcon={seeConfig ? <IconArrowLineLeft /> : <Sliders />}
              >
                {t(seeConfig ? 'noun:reportList' : 'noun:reportConfig')}
              </Button>
              {/* <Button
                className={classes.viewButtons}
                variant="text"
                size="small"
                startIcon={<Sliders />}
              >
                {t('noun:filters')}
              </Button> */}
            </>
          )}
        </Box>
      </Box>
      {children}
    </Box>
  )
}

ReportsView.propTypes = {
  children: PropTypes.node,
  onClickConfig: PropTypes.func,
  seeConfig: PropTypes.bool,
  showAlert: PropTypes.object,
}

export default ReportsView
